import React, { useState } from "react";
import { Container, Row, Col, Card, Badge, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Ventures.css";

const ventures = [
  {
    name: "Nandanam Farms",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
    description: "Premium farmland investment venture offering sustainable returns and scenic landscapes.",
    link: "/ventures/nandanam",
  },
  {
    name: "Green Meadow Estate",
    image: "https://avenuerealty.in/wp-content/uploads/2022/12/839x1191_Floor-Plans-01.jpg",
    description: "A serene project focused on eco-living with well-planned layouts and plantation plots.",
    link: "/ventures/green-meadow",
  },
  {
    name: "Nature Nest Plots",
    image: "https://www.ekoprivilege.com/blog/wp-content/uploads/2024/12/Resort-outer-9-7.jpg",
    description: "Experience a perfect blend of nature and investment opportunity in our latest venture.",
    link: "/ventures/nature-nest",
  },
  {
    name: "EcoVista Acres",
    image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
    description: "An upcoming gated farmland project with greenery, infrastructure, and peaceful vibes.",
    link: "/ventures/ecovista",
  },
  {
    name: "Sandalwood Grove",
    image: "https://www.realhome.in/wp-content/uploads/2020/08/Plantation-L.jpg",
    description: "A red sandalwood plantation project offering high returns with secure compound layout.",
    link: "/ventures/sandalwood-grove",
  },
  {
    name: "Hilltop Greens",
    image: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=800&q=80",
    description: "Lush green plots on a scenic elevation with peaceful weekend getaway options.",
    link: "/ventures/hilltop-greens",
  },
];


const mediaItems = [
  {
    type: "image",
    src: "https://images.unsplash.com/photo-1597007616565-48d70e41e6c4?auto=format&fit=crop&w=800&q=80",
    alt: "Venture 1",
  },
  {
    type: "video",
    src: "https://www.w3schools.com/html/mov_bbb.mp4",
    alt: "Venture Video 1",
  },
  {
    type: "image",
    src: "https://images.unsplash.com/photo-1600585154235-993c5487f9b5?auto=format&fit=crop&w=800&q=80",
    alt: "Venture 2",
  },
  {
    type: "image",
    src: "https://images.unsplash.com/photo-1597262975002-c5c3b14bbd62?auto=format&fit=crop&w=800&q=80",
    alt: "Venture 3",
  },
  {
    type: "video",
    src: "https://www.w3schools.com/html/movie.mp4",
    alt: "Venture Video 2",
  },
  {
    type: "image",
    src: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=800&q=80",
    alt: "Venture 4",
  },
];

const venturesByYear = {
  2023: [
    {
      name: "Nandanam Farms",
      image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=800&q=80",
      summary: "A premium red sandalwood investment opportunity in Telangana.",
    },
    {
      name: "Green Meadows",
      image: "https://images.unsplash.com/photo-1602524816023-fbd188c73b83?auto=format&fit=crop&w=800&q=80",
      summary: "Eco-friendly gated farmland community with drip irrigation.",
    },
  ],
  2022: [
    {
      name: "Sunshine Agro",
      image: "https://images.unsplash.com/photo-1616401785812-c7c12ed53e94?auto=format&fit=crop&w=800&q=80",
      summary: "30-acre mango and sandalwood plantation with road connectivity.",
    },
  ],
  2021: [
    {
      name: "EcoHarvest",
      image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=800&q=80",
      summary: "High-yield organic farming venture with investor cabins.",
    },
  ],
};

const VenturesOverview = () => {
  const [show, setShow] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);

  const handleShow = (item) => {
    setPreviewItem(item);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setPreviewItem(null);
  };

  return (
    <div className="ventures-page">
      {/* Hero Section */}
      <header className="ventures-hero text-white text-center">
        <div className="overlay">
          <h1>Nandanam Ventures</h1>
          <p>Explore our thoughtfully planned green investment projects</p>
        </div>
      </header>

      {/* Featured Ventures */}
      <section className="featured-ventures">
        <h1 className="text-center mb-5 fw-bold">Our Featured Projects</h1>
        <Container>
          <Row>
            {ventures.map((venture, index) => (
              <Col md={6} lg={4} key={index} className="mb-4">
                <Link to={venture.link} className="text-decoration-none text-dark">
   <Card className="venture-card">
  <Card.Img variant="top" src={venture.image} />
                    <Card.Body>
                      <Card.Title>{venture.name}</Card.Title>
                      <Card.Text>{venture.description}</Card.Text>
                    </Card.Body>
                  </Card>
                </Link>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

    {/* Nandanam Project Fullscreen Video */}
<div className="nandanam-video-section-1">
  <Container fluid className="p-0">
    <div className="video-fullscreen-wrapper-1">
      <iframe
        src="https://www.youtube.com/embed/PG4rtGhWK1g"
        title="Nandanam Farms Overview"
        allowFullScreen
      ></iframe>
    </div>
  </Container>

 <Container className="my-5">
  <Row>
    <Col md={6}>
      <Row className="g-3">
        {[
          { icon: "bi-shield-check", text: "100% Clear Title" },
          { icon: "bi-tree", text: "Red Sandalwood Plantation" },
          { icon: "bi-droplet-half", text: "Drip Irrigation System" },
          { icon: "bi-shield-lock", text: "24/7 Security" },
          { icon: "bi-house-door", text: "Gated Compound" },
          { icon: "bi-signpost-2", text: "Proximity to National Highway" },
          { icon: "bi-file-earmark-text", text: "Legal Documentation Provided" },
        ].map((item, idx) => (
          <Col xs={12} key={idx}>
            <Card className="d-flex flex-row align-items-center p-3 shadow-sm feature-card">
              <i className={`bi ${item.icon} fs-3 text-primary me-3`}></i>
              <div className="fs-5 fw-medium">{item.text}</div>
            </Card>
          </Col>
        ))}
      </Row>
    </Col>

    <Col md={6}>
      <img
        src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
        alt="Nandanam Farms"
        className="img-fluid rounded shadow"
      />
      <img src="https://im.proptiger.com/1/3243214/7/edge-master-plan-149549794.jpeg" alt="" />
    </Col>
  </Row>
</Container>

</div>



      {/* Venture Gallery */}
      <div className="venture-gallery">
        <div className="text-center gallery-header">
          <h1>Venture Gallery</h1>
          <p className="lead">Explore visuals of our farmland ventures and developments</p>
        </div>

        <Container>
          <Row>
            {mediaItems.map((item, idx) => (
              <Col md={4} key={idx} className="mb-4">
                <div className="media-box" onClick={() => handleShow(item)}>
                  {item.type === "image" ? (
                    <img src={item.src} alt={item.alt} className="img-fluid media-thumb" />
                  ) : (
                    <video
                      src={item.src}
                      className="img-fluid media-thumb"
                      muted
                      loop
                      playsInline
                      onMouseOver={(e) => e.target.play()}
                      onMouseOut={(e) => e.target.pause()}
                    />
                  )}
                </div>
              </Col>
            ))}
          </Row>
        </Container>

        {/* Modal Preview */}
        <Modal show={show} onHide={handleClose} centered size="lg">
          <Modal.Body className="text-center bg-dark">
            {previewItem && previewItem.type === "image" ? (
              <img src={previewItem.src} alt={previewItem.alt} className="img-fluid" />
            ) : (
              <video src={previewItem?.src} controls autoPlay className="img-fluid" />
            )}
          </Modal.Body>
        </Modal>
      </div>

      {/* Project Timeline */}
      <div className="ventures-timeline">
        <header className="text-center py-5 bg-success text-white">
          <h1>All Venture Projects</h1>
          <p className="lead">Timeline of our projects by launch year</p>
        </header>

        <Container className="my-5">
          {Object.entries(venturesByYear).map(([year, ventures]) => (
            <div key={year} className="mb-5">
              <h3 className="year-title mb-4">{year}</h3>
              <Row>
                {ventures.map((venture, idx) => (
                  <Col md={4} key={idx} className="mb-4">
                    <Card className="venture-card">
                      <Card.Img variant="top" src={venture.image} />
                      <Card.Body>
                        <Card.Title>{venture.name}</Card.Title>
                        <Card.Text>{venture.summary}</Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            </div>
          ))}
        </Container>
      </div>
    </div>
  );
};

export default VenturesOverview;
